import { useEffect } from 'react';
import { useSelector } from 'store';
import { useSnackbar } from 'notistack';

const Snackbar = () => {
    const { message, variant, key, duration } = useSelector((state) => state.snackbar);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!message) return;

        enqueueSnackbar(message, {
            variant,
            preventDuplicate: true,
            autoHideDuration: duration ?? 3000,
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' }
        });
    }, [enqueueSnackbar, message, variant, duration, key]);

    return null;
};

export default Snackbar;
